import React, { ReactElement } from "react";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import Table from '@mui/material/Table';
import Paper from "@mui/material/Paper";
import { StyledTableCell } from "../ShipmentSummary/components/SummaryGrid/SummaryGrid";
import { TABLE_BORDER_GRAY } from "../../constants/css.constants";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Error, Loop } from "@mui/icons-material";
type BaseTableProps = {
  data: Array<Array<string | number>>;
  horizontalHeaders: string[];
  tab: string;
  verticalHeaders: string[];
  innerCell: (
    value: number | string,
    column: number,
    row: number,
  ) => ReactElement;
  loading?: boolean;
  error?: boolean;
};
const BaseTable = ({
  data,
  horizontalHeaders,
  innerCell,
  tab,
  verticalHeaders,
  loading = false,
  error = false,
}: BaseTableProps) => {
  return (
    <TableContainer component={Paper} style={{ overflow: "visible" }}>
    <Table size="small">
      <TableHead>
        <TableRow>
          <StyledTableCell
            cssProperties={{
              borderTop: TABLE_BORDER_GRAY,
              borderLeft: TABLE_BORDER_GRAY,
              minWidth: "200px",
            }}
            padding='none'
            size='small'
          >
            <Typography variant="h6">{tab}</Typography>
          </StyledTableCell>
          {horizontalHeaders.map((season) => (
            <StyledTableCell
              key={season}
              cssProperties={{
                borderTop: TABLE_BORDER_GRAY,
                width: "100px",
                whiteSpace: "nowrap",
              }}
              padding='none'
              size='small'
            >
              {season}
            </StyledTableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody style={{ position: "relative" }}>
        <>
          {(loading || error) && (
            <Box
              position="absolute"
              width="100%"
              height="100%"
              display="flex"
              justifyContent="center"
              alignItems="center"
              style={{ backgroundColor: "#000", opacity: "25%" }}
            >
              {loading ? <Loop /> : <Error />}
            </Box>
          )}
          {data.map((innerData, row) => (
            <TableRow key={`${verticalHeaders.join("")}-${row * 13 + 1}`}>
              <StyledTableCell
                cssProperties={{
                  minWidth: "100px",
                  borderLeft: TABLE_BORDER_GRAY,
                  whiteSpace: "nowrap",
                }}
                padding='none'
                size='small'
              >
                {verticalHeaders[row]}
              </StyledTableCell>
              {innerData.map((value, column) => innerCell(value, column, row))}
            </TableRow>
          ))}
        </>
      </TableBody>
    </Table>
    </TableContainer>
  );
};

export default BaseTable;
